import React, { useEffect, useState, useRef } from "react"
import imagingSearchStyles from "./ImagingSearch.module.css"
import PopularPackages from "../../components/Redcliffe-Imaging/ImagingSearchAccordion/Packages/Packages"
import SearchBar from "../../components/Redcliffe-Imaging/ImagingSearchAccordion/SearchBar/SearchBar"
import RecentSearches from "../../components/Redcliffe-Imaging/ImagingSearchAccordion/RecentSearches/RecentSearches"
// import { getBlogs } from "../../src/slice/HomePageSlice"
// import { useDispatch, useSelector } from "react-redux"
import { Divider } from "@mui/material"
// import outsideClickHandler from "../outsideClickHandler"
// import ImagingAddressPopUpModal from "../ImagingAddressPopUpModal/ImagingAddressPopUpModal"
import { ImagingAddressSelect } from "../../components/Redcliffe-Imaging/ImagingAddressPopUpModal/ImagingAddressPopUpModal"
import Header from "../../components/Redcliffe-Imaging/ImagingNewHeader"
import Footer from "../../components/Redcliffe-Imaging/ImagingFooter"
import Modal from "react-responsive-modal"
import FooterForm from "../../components/Footer/FooterForm"


const ImagingSearch = () => {
  // const dispatch = useDispatch();
  // const blogsData = useSelector((state) => state.homepageSlice.blogs);
  // const data = blogsData.length !== 0 ? blogsData : [];
  const [searchValue, setSearchValue] = useState("");

  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [slug, setSlug] = useState("");
  const [type, setType] = useState("");

  const handleAddressModalOpen = (slug, type = "book") => {
    setOpenAddressModal(true);
    setSlug(slug)
    setType(type);
  }

  const handleAddressModalClose = () => {
    setSlug("")
    setType("");
    setOpenAddressModal(false);
  }

  const [open, setOpen] = useState(false);

  const onOpenModal = () => {
    setOpen(true);
  };

  const onCloseModal = () => {
    setOpen(false)
  }

  return (
    <>
      <Header />
      <div
        id="search-accordion"
        className={`${imagingSearchStyles.container}`}
      >
        <div className={imagingSearchStyles.mainContent}>
          <SearchBar searchValue={searchValue} setSearchValue={setSearchValue} handleAddressModalOpen={handleAddressModalOpen} onOpenModal={onOpenModal} />
          <RecentSearches searchValue={searchValue} setSearchValue={setSearchValue} handleAddressModalOpen={handleAddressModalOpen} onOpenModal={onOpenModal} />
          <Divider style={{ marginTop: "3rem" }} />
          <PopularPackages handleAddressModalOpen={handleAddressModalOpen} />
          <Divider />
        </div>

        <Modal
          open={openAddressModal}
          onClose={handleAddressModalClose}
          center
          styles={{
            root: {
              zIndex: "1250",
            },
            overlay: {
              background: "#17181a36 !important",
            },
            modal: {
              maxHeight: "90vh",
              width: "50rem",
              marginTop: "0 !important",
              borderRadius: "7px !important",
            }
          }}
        >
          <ImagingAddressSelect
            slug={slug}
            type={type}
          />
        </Modal>
      </div >
      <Footer telNumber="898 898 0101"/>

      {open && <FooterForm close={onCloseModal} />}

    </>
  )
}

export default {
  component: ImagingSearch
}